export const DateFormats = {
  YYYYMMDD: 'YYYY-MM-DD',
  MMDDYYYY: 'MM/DD/YYYY',
  MMDDYY: 'MM/DD/YY',
  DDMMYYYY: 'DD/MM/YYYY',
  MMDDYYYYHH: 'MM/DD/YYYY h:mm A',
  DDMMMYY: 'DD MMM YY',
  MMDDYYYYHHMM: 'DD/MM/YYYY h:mm',
  MONYYYY: 'MMM YYYY',
  MONYY: 'MMM YY',
  MON: 'MMM',
  MDYYYY1: 'M/D/YYYY',
  MDYYYY2: 'M-D-YYYY',
  YYYYMD: 'YYYY/M/D',
};
